/* eslint-disable @typescript-eslint/camelcase */
import { FcsFlag } from "../../unleash";

export const FlagsDashboardConsole = {
  dashboard_console_performa_iframe: new FcsFlag.Flag(false),
  dashboard_console_current_stt: new FcsFlag.Flag(true),
};

export function initFlagsDashboardConsole() {
  FcsFlag.register("featureDashboardConsole", FlagsDashboardConsole);
}
